export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7976.361668f8.jpg";